import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FaqService } from '../faq.service';
import { OverlayService } from '../../services/overlay.service';
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-faq-topic',
    templateUrl: './faq-topic.component.html',
    styleUrls: ['./faq-topic.component.scss']
})
export class FaqTopicComponent implements OnInit {
    @Input() topic;
    @Output() closeAction = new EventEmitter();

    env = environment;

    form: FormGroup;
    uploadConfig: any;
    resizeWidth: 500;

    newItem = true;
    data = {
        id: '',
        name: '',
        content: '',
        imageUrl: '',
        bannerUrl: '',
        status: true,
    };

    constructor(
        private faqService: FaqService,
        private overlayService: OverlayService,
        private fb: FormBuilder,
    ) {
        this.form = this.fb.group({
            name: ['', [Validators.required, Validators.minLength(3)]],
            content: ['', []],
            imageUrl: ['', []],
            bannerUrl: ['', []],
            status: [true, [Validators.required]],
        });

    }

    ngOnInit(): void {
        if (this.topic) {

            this.data = this.topic;
            this.newItem = false;

            this.form.patchValue({
                name: this.data.name,
                content: this.data.content,
                imageUrl: this.data.imageUrl,
                bannerUrl: this.data.bannerUrl,
                status: this.data.status,
            });
        }

        this.initUpload();

    }

    toggleStatus() {
        if (!this.form.value.status) {
            this.form.patchValue({ status: true });
        } else {
            this.form.patchValue({ status: false });
        }
    }

    initUpload() {
        this.uploadConfig = {
            url: this.env.imageUploadPath + 'cms/images/upload',
            acceptedFiles: 'image/*',
            parallelUploads: 1,
            resizeWidth: this.resizeWidth,
            maxFiles: 1,
            maxFilesize: 5120,
            params: {
                type: 'faq',
                ownerId: 'faq'
            },
            // The API's upload routes now require the admin session: send the cookie and
            // the app-name the API uses to pick auth.app.admin (Dropzone bypasses the interceptor).
            withCredentials: true,
            headers: {
                'api-key': '6bf9284a-ebf9-4afa-a185-4d2b9bb29e85',
                'app-name': 'admin'
            },
        };
    }

    onUploadError(e) {
        this.initUpload();
    }

    onUploadSuccess(type, e) {
        if (type === 'image') {
            this.form.patchValue({
                imageUrl: e[1].data.url,
            });
        } else {
            this.form.patchValue({
                bannerUrl: e[1].data.url,
            });
        }
        this.initUpload();
    }

    uploadprogress(e) {
    }

    deleteImage() {
        this.form.patchValue({ imageUrl: '' });
    }


    close() {
        this.overlayService.closeAll();
    }

    save() {
        this.data.name = this.form.value.name;
        this.data.content = this.form.value.content;
        this.data.imageUrl = this.form.value.imageUrl;
        this.data.bannerUrl = this.form.value.bannerUrl;
        this.data.status = this.form.value.status;

        if (this.newItem) {
            this.faqService.create(this.data).subscribe(data => {
                this.closeAction.emit({ reload: true });
                this.close();
                // this.reload();
            });
        } else {
            this.faqService.update(this.data).subscribe(data => {
                this.closeAction.emit({ reload: true });
                this.close();
                // this.reload();
            });
        }
    }

    reload() {
        this.faqService.findAllTopics().subscribe();
        this.close();
    }

}
